export default "__VITE_ASSET__fc113bad__"